/* eslint-disable import/prefer-default-export */
export const addRedirectParam = (targetPath, redirectPath) => {
  const blacklist = ['/'];

  if (blacklist.indexOf(redirectPath) === -1) {
    return `${targetPath}?redirect=${encodeURIComponent(
      redirectPath[0] === '/' ? redirectPath : `/${redirectPath}`
    )}`;
  }

  return targetPath;
};
